import { render, staticRenderFns } from "./GerenciamentoProdutoTabela.vue?vue&type=template&id=67d63326&scoped=true"
import script from "./GerenciamentoProdutoTabela.vue?vue&type=script&lang=js"
export * from "./GerenciamentoProdutoTabela.vue?vue&type=script&lang=js"
import style0 from "./GerenciamentoProdutoTabela.vue?vue&type=style&index=0&id=67d63326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d63326",
  null
  
)

export default component.exports